module.exports = __webpack_public_path__ + "media/assets/images/aphasia/aphasia-cover-bg-e2d6bd75c0348b78fae7734b3fbc0d7d.png";